import {h, Fragment} from "preact"
import { useFacet } from "@nosto/preact"
import Checkbox from "./elements/Checkbox"
import Icon from "./elements/Icon"
import { sizesOrder } from '../helpers'

export default function Facet({ facet }) {
    const { active, selectedFiltersCount, toggleActive, toggleProductFilter } = useFacet(facet)

    if(facet.name === 'Size') {
        facet.data.sort((a, b) => {
            const indexA = sizesOrder.indexOf(a.value);
            const indexB = sizesOrder.indexOf(b.value);
            if (indexA !== -1 && indexB !== -1) {
                return indexA - indexB;
            } else if (indexA === -1) {
                return 1;
            } else {
                return -1;
            }
        })
    }

    return (
        <li class={`ns-sidebar-dropdown Collapsible Collapsible--padded ${active ? "ns-active" : ""}`}>
            <a
                class="ns-d-inline-block ns-relative ns-w-100 ns-border-box ns-text-undecorated Collapsible__Button Heading u-h6"
                href="javascript:void(0)"
                data-nosto-element="facet"
                aria-expanded={active}
                onClick={toggleActive}
            >
                <span>{facet.name}</span>
                <span class="Collapsible__Plus"></span>

            </a>
            <div class="ns-sidebar-submenu ns-d-none Collapsible__Inner">
                <div class="Collapsible__Content">
                <ul class="ns-list-unstyled Linklist">
                    {facet.data?.map(value => (
                        <li
                            class="ns-d-flex ns-align-items-center Linklist__Item"
                            data-nosto-element="facet-setting"
                            onClick={e => {
                                e.preventDefault()
                                toggleProductFilter(facet.field, value.value, !value.selected)
                            }}
                        >
                            <input type="checkbox" class="Linklist__Checkbox u-visually-hidden" checked={value.selected} />
                            <label class={`ns-checkbox ns-d-block Text--subdued Link Link--primary`}>
                                {`${value.value} (${value.count})`}
                            </label>
                        </li>
                    ))}
                </ul>
                </div>
            </div>
        </li>
    )
}
